module.exports = __webpack_public_path__ + "static/img/bg-map.bd38d7c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg-map.png
// module id = bfKJ
// module chunks = 1